import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 2,
  class: "text-sm text-gray-500 mt-1"
}

import { ref, watch } from 'vue';
  import { useNotification } from '@kyvg/vue3-notification';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'editInputCustom',
  props: {
    modelValue: {},
    title: {},
    id: {},
    type: {},
    tooltipText: {},
    validation: {},
    validationText: {},
    isButton: { type: Boolean },
    buttonIcon: {}
  },
  emits: ['update:modelValue', 'button-click'],
  setup(__props: any, { emit: __emit }) {

  const { notify } = useNotification();
  const props = __props;

  const emit = __emit;

  const inputValue = ref<number | string>(props.modelValue);

  watch(inputValue, (newValue, oldValue) => {
    if (typeof props.validation === 'function') {
      if (!props.validation(newValue)) {
        inputValue.value = oldValue;
        notify({
          type: 'error',
          title: 'Validation',
          text: props.validationText,
        });
        return;
      }
    }
    emit('update:modelValue', newValue);
  });

  watch(
    () => props.modelValue,
    (newValue) => {
      inputValue.value = newValue;
    }
  );

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IftaLabel = _resolveComponent("IftaLabel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isButton)
      ? (_openBlock(), _createBlock(_component_IftaLabel, {
          key: 0,
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: _ctx.id,
              type: _ctx.type,
              modelValue: inputValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event))
            }, null, 8, ["id", "type", "modelValue"]),
            _createElementVNode("label", { for: _ctx.id }, _toDisplayString(_ctx.title), 9, _hoisted_2)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_InputGroup, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_IftaLabel, { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  id: _ctx.id,
                  type: _ctx.type,
                  modelValue: inputValue.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event))
                }, null, 8, ["id", "type", "modelValue"]),
                _createElementVNode("label", { for: _ctx.id }, _toDisplayString(_ctx.title), 9, _hoisted_3)
              ]),
              _: 1
            }),
            (_ctx.isButton)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: _ctx.buttonIcon,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('button-click')))
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })),
    (_ctx.tooltipText)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.tooltipText), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})